<template>
  <div class="feedbackPage">
    <zdy-nav title="异常反馈" @back="back" @close="close"></zdy-nav>
    <div class="feedContent" ref="feedContent">
      <van-cell-group>
        <van-cell title="手机类型" :value="userInfo.phoneType === 2 ? 'Android' : 'iOS'" />
        <van-cell title="品牌型号" :value="userInfo.model" />
        <van-cell title="软件版本" :value="userInfo.versionCode" />
      </van-cell-group>
      <van-cell-group style="margin-top:15px;">
        <van-cell title="问题类型">
          <template >
            <span class="custom-title" @click="chooseFAQType">
              <span v-if="selectedFAQType">{{ selectedFAQType }}</span>
              <span v-else>请选择</span>
            </span>
          </template>
        </van-cell>
        <van-cell title="问题描述">
          <template slot="label">
            <van-field
              v-model="FAQType.remark"
              type="textarea"
              rows=""
              maxlength="600"
              show-word-limit
              placeholder="请填写" />

            <cube-upload
              v-model="upFileList"
              :action="{
                target: '/api/blade-platform/serviceInfo/upload',
                data: {fileType:1}
              }"
              multiple
              :size="5"
              :max="9"
              @file-success="fileSuccess"
              @file-removed="fileRemove"
              @file-click="handleImgsClick"
              :simultaneous-uploads="1"
              @files-added="filesAdded" />
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <van-button type="info" size="large" class="bottomBtnClass" :disabled="btnLoading" @click="saveInfoBefore">提 交</van-button>
  </div>
</template>

<script>
import { isFulfilled } from 'q';
export default {
  name: 'feedbackPage',
  data() {
    return {
      btnLoading: false,
      picker: '',
      faqTypeList: [],
      upFileList: [],
      imgList: [],
      selectedFAQType: '',
      FAQType: {
        typeID: '',
        remark: '',
        fileList: [],
      },
      initialIndex: 0,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
  },
  created() {
    this.getQuestionTypeList()
  },
  methods: {
    handleImgsClick(file) {
      let url = file.response.data[0].oUrl
      let imgIndex = 0
      for(var i in this.FAQType.fileList) {
        if (this.FAQType.fileList[i] == url) {
          imgIndex = i
        }
      }
      this.initialIndex = Number(imgIndex)
      const params = {
        $props: {
          imgs: this.FAQType.fileList,
          initialIndex: 'initialIndex', // 响应式数据的key名
          loop: false
        },
        $events: {
          change: (i) => {
            // 必须更新 initialIndex
            this.initialIndex = i
          }
        }
      }
      this.$createImagePreview({ ...params }).show()
    },
    fileRemove(fileObj) {
      let temp = []
      this.FAQType.fileList.map(item => {
        if (item !== fileObj.response.data[0].oUrl) {
          temp.push(item)
        }
      })
      this.FAQType.fileList = temp
    },
    fileSuccess(fileObj) {
      this.FAQType.fileList.push(fileObj.response.data[0].oUrl)
    },
    getQuestionTypeList() {
      this.$store.dispatch('questionTypeList').then((res) => {
        const { result } = res.data;
        if (res.data.status === 1000) {
          // this.faqTypeList = result
          console.log(result)
          if (result.length !== 0) {
            result.map(item => {
              let temp = {}
              temp.text = item.questionType
              temp.value = item.uuid
              this.faqTypeList.push(temp)
            })
          }
        } else {
          const toast = this.$createToast({
            txt: res.data.msg,
            time: 2000,
            type: 'error',
          });
          toast.show();
        }
      })
    },
    back() {
      this.$router.push({
        name: 'homPage'
      })
    },
    close() {
      console.log(2)
    },
    chooseFAQType() {
      // const column1 = [{ text: '剧毒', value: '1'}, { text: '蚂蚁', value: '2' }, { text: '幽鬼', value: '3' }]
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: '',
          data: [this.faqTypeList],
          onSelect: this.selectHandle,
          onCancel: this.cancelHandle
        })
      }
      this.picker.show()
    },
    selectHandle(selectedVal, selectedIndex, selectedText) {
      this.FAQType.typeID = selectedVal[0]
      this.selectedFAQType = selectedText[0]
    },
    cancelHandle() {
    },
    filesAdded(files) {
      let hasIgnore = false
      let typeIgnore = false
      let lengthIgnore = false
      const maxSize = 5 * 1024 * 1024 // 5M
      
      const file = files[0]
      if (this.FAQType.fileList.length >= 9) {
        file.ignore = true
        lengthIgnore = true
      }
      lengthIgnore && this.$createToast({
        type: 'warn',
        time: 1500,
        txt: '上传图片不能超过9张'
      }).show()

      console.log(file)
      if (file.size > maxSize) {
        file.ignore = true
        hasIgnore = true
      }
      if (file.type !== "image/png" && file.type !== "image/jpeg" && file.type !== "image/jpg") {
        // debugger
        file.ignore = true
        typeIgnore = true
      }
      hasIgnore && this.$createToast({
        type: 'warn',
        time: 1500,
        txt: '上传图片大小不超过5M'
      }).show()
      typeIgnore && this.$createToast({
        type: 'warn',
        time: 1500,
        txt: '上传图片格式不符合规范'
      }).show()
    },
    saveInfoBefore() {
      if (this.FAQType.typeID == '') {
        this.$createToast({
          type: 'warn',
          time: 1000,
          txt: '请选择问题类型'
        }).show()
      } else if (this.FAQType.remark == '') {
        this.$createToast({
          type: 'warn',
          time: 1000,
          txt: '请填写问题描述'
        }).show()
      } else {
        this.saveInfo()
      }
    },
    saveInfo() {
      this.btnLoading = true
      this.$store.dispatch('saveQuestionFeedbackInfo', {
        keyId: this.userInfo.USER_ID,
        useDevice: this.userInfo.phoneType == 2 ? '安卓' : 'iOS',
        deviceType: this.userInfo.model,
        deviceVersion: this.userInfo.versionCode,
        questionType: this.FAQType.typeID,
        question: this.FAQType.remark,
        images: this.FAQType.fileList.join(','),
        type: 1,
        useType: '移动app',
      }).then((res) => {
        const { result } = res.data;
        if (res.data.status === 1000) {
          const toast = this.$createToast({
            txt: '提交成功',
            time: 2000,
            type: 'success',
          });
          toast.show();
          setTimeout(() => {
            this.$router.push({
              name: 'homPage'
            })
            this.btnLoading = false
          }, 2000);
        } else {
          const toast = this.$createToast({
            txt: res.data.msg,
            time: 2000,
            type: 'error',
          });
          toast.show();
        }
      })
    },
  }
}
</script>

<style lang="scss">
.feedbackPage {
  .feedContent {
    background-color: #F6F6F6;
    margin-top: 50px;
    height: calc(100vh - 100px);
    overflow-y: auto;
    .cube-scroll-wrapper {
      padding: 0 10px;
    }
  }
  .cube-upload {
    margin-top: 10px;
    .cube-upload-btn-def {
      width: 60px;
      height: 60px;
    }
    .cube-upload-file-def {
      width: 60px;
      height: 60px;
    }
  }
  .bottomBtnClass {
    position: fixed;
    bottom: 0;
    color: #008BFF;
    background-color: #E2EFF9;
  }  
  .van-button--info {
    border: 0px solid rgb(253, 254, 255);
  }
}
</style>